import { Injectable } from '@angular/core';
import { HelperService } from '../HelperService/helper.service';

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {
  constructor(private helperService: HelperService) {}

  checkAccess( itemName1: string, itemName2: string) {
    const roleAccessResult = JSON.parse(this.helperService.decryption(localStorage.getItem('roleAccessResult')));
    const item1 = roleAccessResult.find((x: any) => x.com_page_title === itemName1);
    const item2 = roleAccessResult.find((x: any) => x.com_page_title === itemName2);

    const isAccessRead = item1 ? item1.cac_isAllowed : false;
    const isAccessReadWrite = item2 ? item2.cac_isAllowed : false;
  
    // Check conditions and set item1 and item2 accordingly
    if (!isAccessRead && !isAccessReadWrite) {
      return {
        isAccessRead: true,
        isAccessReadWrite: false
      };
    } else if (isAccessRead && isAccessReadWrite) {
      return {
        isAccessRead: false,
        isAccessReadWrite: true
      };
    } else {
      return {
        isAccessRead,
        isAccessReadWrite
      };
    }
  }
}
